import React from 'react';
import { connect } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { shellHomePath, shellKindFromState } from '../utils/managementShell';

/**
 * When current org is a management firm, keep `/` off the SME emissions dashboard.
 */
const ShellHomeRedirect = ({ kind }) => {
  const location = useLocation();
  if (!kind) return null;
  if (location.pathname === '/' || location.pathname === '') {
    return <Redirect to={shellHomePath(kind)} />;
  }
  return null;
};

const mapStateToProps = (state) => ({
  kind: shellKindFromState(state),
});

export default connect(mapStateToProps)(ShellHomeRedirect);
